import { Show, createEffect, createSignal } from "solid-js";
import STButton, { ButtonType } from "../st-button/st-button";
import STModal from "../st-modal/st-modal";
import { requireReportBrowser } from "./report-browser-context";

export default function DeleteDialog() {
  const reportBrowser = requireReportBrowser()
  const [isOpen, setIsOpen] = createSignal(reportBrowser.state.isDeleteDialogOpen)
  
  createEffect(() => { setIsOpen(reportBrowser.state.isDeleteDialogOpen) })

  createEffect(() => {
    if (isOpen() !== reportBrowser.state.isDeleteDialogOpen) {
      if (isOpen() === false) {
        reportBrowser.cancelCopy()
      }
    }
  })

  return (
    <Show when={reportBrowser.selectedReport()}>
      <STModal show={[isOpen, setIsOpen]}>
        <span>Are you sure?</span>
        <div class="delete-actions">
          <STButton onClick={reportBrowser.cancelDelete}>Cancel</STButton>
          <STButton onClick={() => reportBrowser.deleteReport(reportBrowser.selectedReport()!)} type="danger" loading={reportBrowser.state.isDeleting}>
            Delete
          </STButton>
        </div>
      </STModal>
    </Show>
  );
}
